import { render, staticRenderFns } from "./MessageCenterManager.vue?vue&type=template&id=796bbe22&scoped=true"
import script from "./MessageCenterManager.vue?vue&type=script&lang=js"
export * from "./MessageCenterManager.vue?vue&type=script&lang=js"
import style0 from "./MessageCenterManager.vue?vue&type=style&index=0&id=796bbe22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796bbe22",
  null
  
)

export default component.exports